import styled, { css, keyframes } from 'styled-components';

import { BREAKPOINTS } from '@/constants/breakpoints';

export const flexCenterAligned = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const flexColumn = css`
  display: flex;
  flex-direction: column;
`;

export const flexRow = css`
  display: flex;
  flex-direction: row;
`;

export const flexBetween = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ellipsisText = css`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const scrollStyles = css`
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    width: 4px;
    height: 59px;
    border-radius: 7px;
    background-color: #b1b8c6;
  }
`;

export const scrollHidden = css`
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`;

export const SpaceColumn = styled.div<{ $gap?: number; $center?: boolean }>`
  ${flexColumn};
  gap: ${({ $gap }) => $gap ?? 0}px;
  width: inherit;
  ${({ $center }) =>
    $center && 'align-items: center; justify-content: center;'};
`;

export const SpaceRow = styled.div<{ $gap?: number; $center?: boolean }>`
  ${flexRow};
  gap: ${({ $gap }) => $gap ?? 0}px;
  ${({ $center }) =>
    $center && 'align-items: center; justify-content: center;'};
`;

type transitionKeys = 'visibility' | 'transform' | 'opacity';
type transitionType = Partial<Record<transitionKeys, boolean>> | undefined;

export const openingEffect = (
  offset: number = -10,
  transition: transitionType = {
    opacity: true,
    transform: true,
    visibility: true
  }
) => css<{
  $isOpen: boolean;
}>`
  transition: ${Object.entries(transition ?? [])
    .map(([key, value]) => (value ? `${key} 0.3s ease` : ''))
    .filter(Boolean)
    .join(', ')};

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          visibility: visible;
          opacity: 1;
          transform: translateY(0);
        `
      : css`
          visibility: hidden;
          opacity: 0;
          transform: translateY(${offset}px);
        `};
`;

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`;

export const commonSkeletonStyles = css`
  background: linear-gradient(
    90deg,
    var(--border-secondary) 25%,
    var(--border-main) 50%,
    var(--border-secondary) 75%
  );
  background-size: 400px 100%;
  animation: ${shimmer} 1.5s infinite;
`;

export const paddingInline = css`
  padding-inline: var(--px-xl);

  @media (max-width: ${BREAKPOINTS.desktop}) {
    padding-inline: var(--px-md);
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding-inline: var(--px-sm);
  }
`;

export const decorationLink = css`
  text-decoration-line: underline;
  text-decoration-color: currentColor;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  -webkit-text-decoration-skip: none;
  text-decoration-skip: none;

  text-underline-offset: 2px;
  text-decoration-thickness: 1px;

  &:hover {
    text-decoration-color: currentColor;
  }
`;

export const commonLinkStyles = css`
  transition: color 0.3s ease;

  &:hover {
    color: var(--custom-yellow);
  }
`;
